import React from "react";
import { IconText, Theme } from "sprint-common-web";

import { AssetAvailabilityAction, OrderAuditItem } from "../AuditItem";
import { OrderAuditType } from "../AuditListAside";
import { renderSimpleChangeInfo } from "./renderAuditInfo";

type Props = { item: OrderAuditItem; type: OrderAuditType };

export const AssetChangeInfo: React.FC<Props> = ({ item, type }) => {
    const assetInfoChanges: JSX.Element[] = [];

    const getIconColor = (action: AssetAvailabilityAction) => {
        if (action === AssetAvailabilityAction.Removed) {
            return Theme.palette.neutralTertiary;
        }

        if (type === OrderAuditType.Cloud) {
            return Theme.palette.green;
        } else {
            return Theme.palette.blue;
        }
    };

    if (item.video) {
        assetInfoChanges.push(
            <IconText
                text={"Video"}
                iconName={"StatusCircleInner"}
                textVariant={"smallPlus"}
                iconColor={getIconColor(item.video)}
            />
        );
    }

    if (item.subtitles?.length) {
        assetInfoChanges.push(
            <>
                {item.subtitles.map((subtitle) => {
                    if ("action" in subtitle) {
                        console.log("into action");
                        return (
                            <IconText
                                key={subtitle.language.id}
                                text={"Subtitle: " + subtitle.language.name}
                                iconName={"StatusCircleInner"}
                                textVariant={"smallPlus"}
                                iconColor={getIconColor(subtitle.action)}
                            />
                        );
                    }

                    return (
                        <>
                            {renderSimpleChangeInfo({
                                ...subtitle.filename,
                                label: `Subtitle ${subtitle.language.name} filename:`
                            })}
                        </>
                    );
                })}
            </>
        );
    }

    if (item.soundtracks?.length) {
        assetInfoChanges.push(
            <>
                {item.soundtracks.map((soundtrack) => (
                    <IconText
                        key={soundtrack.language.id}
                        text={"Soundtrack: " + soundtrack.language.name}
                        iconName={"StatusCircleInner"}
                        textVariant={"smallPlus"}
                        iconColor={getIconColor(soundtrack.action)}
                    />
                ))}
            </>
        );
    }

    return <>{assetInfoChanges}</>;
};
